/* global _env */

/**
 * Lock
 * LocalStorageにタイムスタンプを記録して現時刻と比較する.
 *
 * @param period<number>
 * @return {Promise<unknown>}
 */
export default ( period ) => {
	return new Promise( ( resolve, reject ) => {

		// 設定値がマイナスの場合は、ロック機構を回避する
		if ( period < 0 ) {
			resolve();
		}

		/**
		 * lock
		 * 使用した履歴をタイムスタンプのミリ秒
		 * @type {string}
		 */
		const lock = localStorage.getItem( `illumination_lock_${_env.project}` );

		/** 記録がある場合 */
		if ( lock ) {
			/**
			 * now
			 * UTC (協定世界時) での 1970年1月1日0時0分0秒 から現在までの経過時間をミリ秒単位
			 * @type {number}
			 */
			const now = Date.now();

			/**
			 * limit
			 * ロックされる期限ミリ秒で設定する
			 * @type {number}
			 */
			const limit = parseInt( lock ) + period;

			// 現在時がリミットより少ない場合はロック
			if ( now <= limit ) {
				reject();
			} else {
				resolve();
			}

		} else {
			// 記録がなければロック機構を回避する
			resolve();
		}

	} );
}
